export default {
  // apiUrl: "https://localhost:44389/api/",
  // contentUrl: "https://sttbloblive.blob.core.windows.net/sampleimage/",
  // contentUrlApi: "https://localhost:44389/",
  // SamplefilesDownload: "https://localhost:44389/demo.xlsx",
  // FrontUrl: "https://localhost:3000/",


  //Loved one qrcode test
   apiUrl: "https://api.lifetags.io/api/",
  contentUrl: "https://sttbloblive.blob.core.windows.net/sampleimage/",
  contentUrlApi: "https://api.lifetags.io/",
  SamplefilesDownload: "https://api.lifetags.io/demo.xlsx",
  FrontUrl: "https://web.lifetags.io/",

  // apiUrl: "https://api.qrcode-stt.com/api/",
  // contentUrl: "https://sttbloblive.blob.core.windows.net/sampleimage/",
  // contentUrlApi: "https://api.qrcode-stt.com/",
  // SamplefilesDownload: "https://api.qrcode-stt.com/demo.xlsx",
  // FrontUrl: "https://app.qrcode-stt.com/",

   MaximumVideoFileSize: 20000000,

  //Test
  // Secret_key:
  //   "sk_test_51NJTNAFMYmPu5aEaptWm9LO5jYncPnzT5PXMTOcqF27eA0ud47d9ZlN3EM6PAOBFFmn0IIZltmee3EV7x0iExTAp00fcdyCkgQ",
  // STRIPE_PUBLISHABLE_KEY:
  //   "pk_test_51NJTNAFMYmPu5aEaC4Ku5Jrq78Wmni0GfKkCRPkD1lIULIRekytydBiXcNGJ6mzi2MWyMNmj72XF95Z4Dj0f2Fim00G9QF2uuc",

  // CURRENCY: "GBP",
 
  //STT Live
  Secret_key:
    "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",
  STRIPE_PUBLISHABLE_KEY:
    "pk_live_51NJTNAFMYmPu5aEaeBrooWt2PCjSRabPUxZSJIOVWEn2fJ8rL6jMFjCXhYACfdVGfWOgUmTPGH4Y1g6TVoGtTPoF00n64e7gpQ",


  androidUrl:"intent://stt.com/#Intent;scheme=https;package=com.scantotellv1.stt;end",
  iOSUrl:"https://apps.apple.com/us/app/scan-to-tell/id6447886146",
  videolink :"https://www.youtube.com/watch?v=noRAePw9Rdk",
  sttbloblive : "https://sttbloblive.blob.core.windows.net/sampleimage/",
  
  ipinfoapi:"https://ipinfo.io/json?token=",
  ipinfotoken:"af4176e2a44f07",

  ipify:'https://api.ipify.org/?format=json',

  //razorpaypublishablekey:"rzp_test_za0okrn2vooP0x"
  
  //test
  //razorpaypublishablekey:"rzp_test_8MY5xxDp9iIpZB"
  //live
  razorpaypublishablekey:"rzp_live_HAOyLYJyzz1ceA"

};
